import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";

import Footer from "../../components/FooterAdmin.js";
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_view: false,

      filter_search: "",

      data: [],

      uid: "",
      product: [],
      full_name: "",
      email: "",
      phone: "",
      message: "",
    };
  }

  async componentDidMount(){
  loading(false);
  if (!profile || profile?.ep < new Date().getTime()) {
      localStorage.removeItem("scp-profile");
      alert(
        "/login",
        "warning",
        "แจ้งเตือน",
        "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
      );
    }else{
      await this.Get();
    }
  }
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/contact.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    this.setState({ data: (result ? Object.values(result) : []).sort((a,b) => b.uid -a.uid) });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, photo, name, sector, address } = this.state;
    loading(true);

    let now = new Date().getTime();
    await fetch(
      process.env.REACT_APP_API_URL +
        `/contact/${uid || now}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: uid || now,
          photo,
          name,
          sector,
          address,
        }),
      }
    );
    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };

  render() {
    const {
      modal_view,
      filter_search,
      data,

      uid,
      product,
      full_name,
      email,
      phone,
      message,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3">
          <h4 className="fw-bold mb-4">ติดต่อ/ใบเสนอราคา</h4>
          <div className="rounded-3 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3">
              <span className="icon me-1 text-14">{"\uf0b0"}</span>ฟิลเตอร์
            </h5>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-warning px-3 me-2 mb-2"
                  onClick={() => {}}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({ filter_search: "" });
                  }}
                >
                  ล้างข้อมูล
                </button>
              </div>
            </div>
          </div>
          <div className="rounded-3 bg-white p-3">
            <div className="table-responsive">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td>วันที่</td>
                    <td className="text-nowrap">ชื่อ-นามสกุล</td>
                    <td>อีเมล</td>
                    <td>เบอร์โทร</td>
                    <td>ข้อความ</td>
                    <td className="wpx-80 text-center">จัดการ</td>
                  </tr>
                </thead>
                <tbody>
                  {data
                    ?.filter(
                      (item) =>
                        !filter_search ||
                        (item.full_name + item.email + item.phone).includes(
                          filter_search
                        )
                    )
                    .map((item, index) => (
                      <tr key={`array-${index}`}>
                        <td className="text-nowrap">
                          {format_date(new Date(item.uid), "dd/mm/yyyy hh:mm")}
                        </td>
                        <td>{item.full_name}</td>
                        <td>{item.email}</td>
                        <td>{item.phone}</td>
                        <td>{item.message}</td>
                        <td>
                          <div className="w-100 d-flex justify-content-center">
                            <BtnIcon
                              type="view"
                              onClick={() => {
                                this.setState({ modal_view: true, ...item });
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

<div className="hpx-40"></div>
                <Footer />
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_view}
          onHide={() => this.setState({ modal_view: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายละเอียดติดต่อ</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="row">
              {product && product.length !== 0 && (
                <div className="d-flex mb-2">
                  <div className="mb-2 wpx-120 fw-bold">รุ่นที่ต้องการ</div>
                  <ul>
                    {product.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="d-flex mb-2">
                <div className="mb-2 wpx-120 fw-bold">ชื่อ - นามสกุล</div>
                <div className="mb-2">{full_name}</div>
              </div>
              <div className="d-flex mb-2">
                <div className="mb-2 wpx-120 fw-bold">อีเมล</div>
                <div className="mb-2">{email}</div>
              </div>
              <div className="d-flex mb-2">
                <div className="mb-2 wpx-120 fw-bold">เบอร์โทรศัพท์</div>
                <div className="mb-2">{phone}</div>
              </div>
              <div className="d-flex mb-2">
                <div className="mb-2 wpx-120 fw-bold">ข้อความ</div>
                <div className="mb-2 text-wrap">{message}</div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}
